<template>
  <div class="vc-banner-insight-ia">
    <div class="content">
      <div class="title">
        <div class="title__icon">
          <img :src="iconeIA" alt="icone" />
        </div>
        <div class="title__text">
          {{ defineBanner.title }}
          <span v-if="ativado && defineBanner.periodo">{{
            defineBanner.periodo
          }}</span>
        </div>
      </div>
      <div class="button-ativar" @click="handleClick">
        <img :src="iconeIA" alt="icone" v-if="!ativado" />
        <material-icon
          icon="arrow_outward"
          style="font-size: 14px; margin-top: 2px"
          v-else
        />
        <span>{{ defineBanner.button }}</span>
      </div>
    </div>
    <div class="description" v-html="defineBanner.description"></div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import iconeIA from "./icone-ia-white.svg";

const props = withDefaults(
  defineProps<{
    ativado?: string;
    insights?: string;
    atencao?: string;
    periodo?: string;
    VCBannerClick?: () => void;
  }>(),
  {
    ativado: undefined,
    insights: undefined,
    atencao: undefined,
    periodo: undefined
  }
);

const emits = defineEmits(["VCBannerClick"]);

const handleClick = () => {
  emits("VCBannerClick");
};

const defineBanner = computed(() => {
  if (
    props.ativado === "true" &&
    props.insights &&
    props.atencao &&
    props.periodo
  ) {
    return {
      title: "Seu relatório de insights de DRE está pronto",
      periodo: props.periodo,
      insights: props.insights,
      atencao: props.atencao,
      description: `Identificamos ${props.insights} insights críticos e ${props.atencao} que precisam de atenção na análise vertical deste período.`,
      button: "Ver relatório"
    };
  } else {
    return {
      title: "Antecipe problemas e identifique gastos fora do padrão",
      description: `Ative seu Agente de IA para receber <b>insights inteligentes</b> com diagnóstico, risco e plano de ação para o seu negócio.`,
      button: "Ativar Agente"
    };
  }
});
</script>

<style lang="scss">
.vc-banner-insight-ia {
  background-color: #fff;
  border-radius: 5px;
  font-family: "Plus Jakarta Sans", sans-serif;
  padding: 16px;

  .content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .title {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 7px;

      &__icon {
        width: 24px;
        height: 24px;
        background-color: #0055ff;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &__text {
        font-size: 16px;
        font-weight: 600;
        color: #2e2e2e;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        span {
          font-size: 10px;
          font-weight: 400;
          color: #737373;
        }
      }
    }

    .button-ativar {
      display: flex;
      align-items: center;
      gap: 10px;
      height: 18px;
      background-color: #0055ff;
      border-radius: 5px;
      padding: 8px 12px;
      color: #fff;
      cursor: pointer;
    }

    .button-ativar:hover {
      background-color: #0044cc;
    }
  }

  .description {
    font-size: 14px;
    font-weight: 400;
    color: #2e2e2e;
  }
}
</style>
